import { useEffect, useState } from 'react'
import { Dropdown, Menu } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { IShopByCompany } from '@cbgms/api'
import { useDispatch } from 'react-redux'
import { useQuery } from '@cbgms/base/http/use-query'
import { getExternalSystemsForCompany } from 'app-support/licenses/state/actions'

interface props {
  selectedShop?: IShopByCompany
  companyUUID: string
  onClick: (value: string) => void
}

interface iSuggestionOption {
  text: string
  value: string
  shopID: string
}

const HaynesClientIDSuggestions = ({ selectedShop, onClick, companyUUID }: props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [clientIDSuggestions, setClientIDSuggestions] = useState<iSuggestionOption[]>([])

  const result = useQuery(['HaynesClientIDSuggestions', 'getExternalSystemsForCompany', companyUUID], async () => {
    const registeredSsytems = await dispatch(getExternalSystemsForCompany(companyUUID, ['Mijngrossier']))

    return registeredSsytems?.Data?.map(f => ({
      shopID: f.ShopID,
      value: f.SystemID,
      text: `Shopid: ${f.ShopID} - Mijngrossier: ${f.SystemID}`
    }))
  })

  // filter on shopID whenever it changes
  useEffect(() => {
    if (!result.data) {
      return setClientIDSuggestions([])
    }
    const newIDs = selectedShop?.ID ? result.data.filter(f => f.shopID === selectedShop.ID) : result.data
    setClientIDSuggestions(newIDs)
  }, [result.data, selectedShop])

  return (
    <Menu vertical className='mt0'>
      <Dropdown item text={t('haynes.license_clientid_suggestion')} loading={result.isLoading}>
        <Dropdown.Menu>
          <Dropdown.Header>
            {t(
              clientIDSuggestions?.length ? 'haynes.select_license_clientid_suggestion' : 'haynes.license_clientid_suggestion_not_available'
            )}
          </Dropdown.Header>
          {clientIDSuggestions?.map(item => (
            <Dropdown.Item key={`${item.value}-${item.text}`} onClick={() => onClick(item.value)}>
              {item.text}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Menu>
  )
}

export default HaynesClientIDSuggestions
